import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Reveal } from '../components/Reveal';
import { CTABand } from '../components/CTABand';

export default function Services() {
  const { t } = useLanguage();
  const s = t.services;

  return (
    <div data-testid="page-services">
      {/* Header */}
      <section className="px-6 lg:px-12 pt-32 md:pt-40 pb-16">
        <div className="max-w-[1400px] mx-auto grid md:grid-cols-12 gap-12">
          <div className="md:col-span-2">
            <Reveal>
              <p className="overline">{s.overline}</p>
            </Reveal>
          </div>
          <div className="md:col-span-10">
            <Reveal delay={0.05}>
              <h1
                className="font-serif font-light text-[2.6rem] md:text-[5.4rem] leading-[1] tracking-tight"
                style={{ color: 'var(--ink)' }}
              >
                {s.title}
              </h1>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-8 text-[17px] leading-relaxed max-w-2xl" style={{ color: 'var(--ink-2)' }}>
                {s.lead}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Services list */}
      <section className="px-6 lg:px-12 pb-8">
        <div className="max-w-[1400px] mx-auto" style={{ borderTop: '1px solid var(--rule-strong)' }}>
          {s.items.map((item) => (
            <Reveal key={item.n}>
              <div
                className="grid md:grid-cols-12 gap-8 py-14 md:py-20"
                style={{ borderBottom: '1px solid var(--rule)' }}
                data-testid={`service-${item.n}`}
              >
                <div className="md:col-span-2">
                  <span className="font-serif italic text-xl" style={{ color: 'var(--accent)' }}>
                    {item.n}
                  </span>
                </div>
                <div className="md:col-span-5">
                  <p className="font-serif italic text-lg mb-3" style={{ color: 'var(--ink-3)' }}>
                    {item.label}
                  </p>
                  <h2
                    className="font-serif text-3xl md:text-[2.6rem] font-light leading-tight"
                    style={{ color: 'var(--ink)' }}
                  >
                    {item.title}
                  </h2>
                </div>
                <div className="md:col-span-5">
                  <p className="text-[16px] leading-relaxed" style={{ color: 'var(--ink-2)' }}>
                    {item.description}
                  </p>
                  {item.bullets && (
                    <ul className="mt-6 space-y-2" style={{ color: 'var(--ink-2)' }}>
                      {item.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-3 text-[14px]">
                          <span
                            className="mt-[10px] w-4 h-[1px] shrink-0"
                            style={{ background: 'var(--ink-2)' }}
                          />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand title={s.closingTitle} body={s.closingBody} testid="services-cta" />
    </div>
  );
}
